var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMark4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 188.43 67.16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n        stroke-width: 0px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_1",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M20.79,67.13c-5.61-.22-10.21-1.76-13.8-4.61-.69-.55-2.32-2.18-2.87-2.87-1.46-1.83-2.45-3.61-3.11-5.59-2.03-6.09-.99-14.08,2.99-22.84,3.41-7.51,8.66-14.95,17.83-25.26,1.35-1.52,5.37-5.95,5.4-5.95,0,0-.21.38-.49.84-2.38,3.99-4.42,8.7-5.54,12.77-1.79,6.53-1.57,12.14.63,16.49,1.52,3,4.12,5.59,7.05,7.02,5.12,2.51,12.62,2.72,21.78.61.63-.15,31.88-8.44,69.45-18.44C157.69,9.31,188.43,1.13,188.43,1.14c.01,0-87.27,37.36-132.58,56.73-7.18,3.07-9.09,3.84-12.47,5.03-8.62,3.03-16.35,4.47-22.59,4.23Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMark4);
export default __webpack_public_path__ + "static/media/mark4.2f0461ca333ff24544e1cc1166ed6bcd.svg";
export { ForwardRef as ReactComponent };